import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConclusionComponent } from 'src/app/@core/models/item-component';

@Component({
  selector: 'app-editor-component-conclusion-config',
  templateUrl: 'conclusion-config.component.html',
})
export class EditorConclusionConfigComponent {
  @Input() item: ConclusionComponent;
  @Input() customData: any;
  @Output() public sendEvent = new EventEmitter<any>();

  setAlign(element: any, align: string) {
    element.align = align;
  }

  emitSendEvent() {
    this.sendEvent.emit();
  }

}
